module.exports = __webpack_public_path__ + "img/ftxus.e0463f13.png";